var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 85,
    viewBox: "0 0 96 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.0374 40.7125L50.7186 59.35C49.5936 61.6187 46.3311 61.5437 45.2999 59.2375L34.6311 35.5562L29.0061 49H11.3624L45.5811 83.9687C46.9124 85.3375 49.0686 85.3375 50.3999 83.9687L84.6374 49H64.1811L60.0374 40.7125ZM88.8186 8.85623L88.3686 8.38748C78.7124 -1.47502 62.9061 -1.47502 53.2311 8.38748L47.9999 13.75L42.7686 8.40622C33.1124 -1.47503 17.2874 -1.47503 7.63111 8.40622L7.18111 8.85623C-1.95014 18.1937 -2.34389 33.0625 5.81236 43H25.0124L31.7436 26.8375C32.7561 24.4187 36.1686 24.3625 37.2561 26.7625L48.1686 51.0062L57.3561 32.65C58.4624 30.4375 61.6124 30.4375 62.7186 32.65L67.8936 43H90.1874C98.3436 33.0625 97.9499 18.1937 88.8186 8.85623Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.9269ba6065dd49698c7e55403a3b7273.svg";
export { ForwardRef as ReactComponent };